const cardItems = [
  {
    title: '《流浪地球3》深度解读',
    desc: '从特效到叙事，解析国产科幻里程碑的进化之路',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20station%20interior%20with%20holographic%20displays%2C%20sleek%20metallic%20surfaces%2C%20blue%20ambient%20lighting%2C%20sci-fi%20cinematic%20aesthetic%2C%20clean%20minimal%20design%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=cards-01&orientation=landscape',
    date: '2026-07-30',
    tag: '深度解读',
  },
  {
    title: '暑期档最值得看的5部新片',
    desc: '七月末八月初必看片单，每一部都不容错过',
    img: 'https://readdy.ai/api/search-image?query=Summer%20cinema%20atmosphere%20with%20warm%20sunset%20light%20streaming%20through%20window%2C%20cozy%20home%20theater%20setup%2C%20popcorn%20and%20drinks%2C%20golden%20hour%20glow%2C%20relaxed%20vibe%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=cards-02&orientation=landscape',
    date: '2026-07-29',
    tag: '观影指南',
  },
  {
    title: '国漫崛起：从《大圣》到《深海》',
    desc: '盘点近十年国产动画的技术突破与美学演变',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20animation%20style%20underwater%20scene%20with%20colorful%20coral%20and%20flowing%20light%20beams%2C%20magical%20fantasy%20atmosphere%2C%20vibrant%20blue%20and%20pink%20hues%2C%20dreamlike%20composition%2C%20no%20text%2C%20no%20characters&width=800&height=500&seq=cards-03&orientation=landscape',
    date: '2026-07-28',
    tag: '专题策划',
  },
  {
    title: '韩剧为何持续霸屏？现象级解析',
    desc: '从《鱿鱼游戏》到《黑暗荣耀》，韩剧的全球影响力密码',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20filming%20set%20atmosphere%20with%20warm%20studio%20lights%2C%20director%20chair%20and%20camera%20equipment%2C%20professional%20film%20production%20vibe%2C%20soft%20cinematic%20lighting%2C%20creative%20workspace%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=cards-04&orientation=landscape',
    date: '2026-07-27',
    tag: '行业观察',
  },
  {
    title: '高分纪录片推荐：打开新世界',
    desc: '自然、历史、科技，10部豆瓣9分以上纪录片精选',
    img: 'https://readdy.ai/api/search-image?query=Breathtaking%20aerial%20landscape%20of%20mountains%20and%20valleys%20at%20golden%20hour%2C%20dramatic%20clouds%2C%20documentary%20cinematography%20style%2C%20vibrant%20natural%20colors%2C%20epic%20scale%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=cards-05&orientation=landscape',
    date: '2026-07-26',
    tag: '片单推荐',
  },
  {
    title: '《咒术回战》最终季追番指南',
    desc: '从第一季到剧场版，完整观剧顺序与精彩看点梳理',
    img: 'https://readdy.ai/api/search-image?query=Dark%20urban%20fantasy%20alleyway%20with%20mysterious%20glowing%20runes%20and%20energy%20effects%2C%20anime%20style%20atmosphere%2C%20dramatic%20lighting%20with%20blue%20and%20purple%20tones%2C%20supernatural%20vibe%2C%20no%20text%2C%20no%20characters&width=800&height=500&seq=cards-06&orientation=landscape',
    date: '2026-07-25',
    tag: '追番指南',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">精选推荐</h2>
          <p className="text-sm text-foreground-500">编辑精选好文，影视资讯与观影指南一网打尽</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {cardItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group rounded-lg overflow-hidden border border-background-200/40 bg-background-100 hover:border-primary-500/20 transition-all cursor-pointer"
            >
              <div className="relative aspect-[8/5] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded text-xs font-medium bg-accent-500 text-background-50">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <i className="ri-calendar-line text-foreground-600 text-xs"></i>
                  <span className="text-xs text-foreground-600">{item.date}</span>
                </div>
                <h3 className="font-heading text-sm md:text-base text-foreground-100 group-hover:text-primary-400 transition-colors mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}